import React from 'react'
import "./shelfDeleteModal.css"

export const ShelfDeleteModal = ({shelfName , shelfDescription , onClose , deleteShelf }) => {

  const handleDeleteShelve = ()=>{
    deleteShelf()
    onClose()
  }
  return (
    <section className='delete-shelf-cont'>
            <h3>Are you sure you want to <br /> delete this Shelf?</h3>
            <div className="delete-shelf-pCont">
                <p>Shelf: <span>{shelfName}</span></p>
                <p>Description: <span>{shelfDescription}</span></p>
            </div>
            <div className='delete-shelf-btnCont'>
                <button onClick={handleDeleteShelve}>Ok</button>
                <button onClick={onClose}>Cancel</button>
            </div>
        </section>
  )
}
